import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { AuthService } from './core/auth/auth.service';
import { LocalStorageService } from './services/local-storage.service';
import { UserService } from './core/user/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    user: SocialUser;
    loggedIn: boolean;

    constructor(
        private authSocialService: SocialAuthService,
        private _activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private userService: UserService,
        private _router: Router,
        private localstorageService: LocalStorageService
    ) {
        //   this.authSocialService.authState.subscribe((user) => {
        //     console.log(user);
        //     this.user = user;
        //     this.loggedIn = (user != null);
        //     if (this.loggedIn) {
        //         const redirectURL = this._activatedRoute.snapshot.queryParamMap.get('redirectURL')
        //             || '/signed-in-redirect';

        //         // Navigate to the redirect url

        //         this.authService.accessToken = this.user.idToken;
        //         this.localstorageService.setItem(environment.common.storageKeys.authToken, this.authService.accessToken);
        //         this.localstorageService.setItem(environment.common.storageKeys.authData, this.user);


        //         // Set the authenticated flag to true
        //         // this.authService._authenticated = true;

        //         this.userService.getGoogleUser().subscribe(res => {
        //             // this.getUserSubscription();

        //         });
        //         this._router.navigateByUrl(redirectURL);


        //     } else {
        //         this._router.navigateByUrl('/sign-in');
        //     }
        // });
    }
}
